<template>
    <div>
        <!-- {{ rows[2] }} -->

        <div class="account_datepicker_filter">
            <div class="input-group">
                <span class="input-group-text" id="basic-addon1"
                    ><i class="las la-calendar"></i
                ></span>
                <select @change="getmonth" class="form-control" name="" id="">
                    <option value="" selected disabled>--Select---</option>
                    <option value="month">Current Month</option>
                    <option value="year">Year</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div
                class="col-md-4 mb-4"
                v-for="(user, index) in rows[0]"
                :key="user.id"
            >
                <div class="card accounting_bill_card">
                    <div class="card-header">
                        {{ rows[1][index] ? rows[1][index].months : rows[2] }}
                        <!-- {{ rows[1][index].months }} -->
                    </div>
                    <div class="card-body">
                        <div class="account_bill_item">
                            <p>Payable Amount</p>
                            <!-- {{ user }} -->
                            <!-- {{parseInt(user.lead_close_amount )+ parseInt(user.lead_generator_amount)+ parseInt(user.upload_document_amount)}} -->
                            <h3 class="badge bg-secondary">{{ user }}</h3>
                        </div>
                        <div class="account_bill_item">
                            <p>Total Loan</p>
                            <a
                                href="#"
                                @click="
                                    listData(
                                        rows[1][index]
                                            ? rows[1][index].months
                                            : rows[2]
                                    )
                                "
                                class="badge bg-secondary"
                            >
                                {{
                                    rows[2][index].data
                                        ? rows[2][index].data
                                        : rows[1]
                                }}
                            </a>
                        </div>
                        <div class="card_btn">
                            <a
                                href="#"
                                class="btn btn-primary btn-sm"
                                @click="toggleCheckbox(user, rows)"
                                ><i class="las la-file-pdf"></i> Download PDF</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import {useRouter} from "vue-router"
// import VueRouter from 'vue-router';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";

export default {
    props: ["slug"],

    name: "DataTableComponent",
    components: { DateRangePicker },
    // router=useRouter()

    data() {
        // const router=useRouter()

        return {
            // router,
            dateRange: {
                startDate: null,
                endDate: null,
                search: null,
                excel: null,
            },
            rows: [],
            page: 1,
            per_page: 10,
            filterData: {
                startDate: null,
                endDate: null,
            },
        };
    },

    methods: {
        getDate(datetime) {
            let date = new Date(datetime)
                .toJSON()
                .slice(0, 10)
                .replace(/-/g, "/");
            return date;
        },
        updateValues() {
            this.getPosts();
        },
        getmonth(para) {
            this.getPosts(para.target.value);
            console.log(para.target.value);
        },

        toggleCheckbox(user, rows) {
            axios({
                url: `/business-partner/download/` + rows[3] + "/" + user,

                method: "POST",

                responseType: "blob",
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );

                var fileLink = document.createElement("a");

                fileLink.href = fileURL;

                fileLink.setAttribute("download", "Invoice.pdf");

                document.body.appendChild(fileLink);

                fileLink.click();
            });
        },
        listData(user) {
            // console.log(rows)
            console.log(user);
            window.location.href = `/business-partner/accounting/` + user;
        },

        getPosts(month) {
            axios.post(this.slug, { params: month }).then(
                function (response) {
                    $(".preloader").hide();

                    this.rows = response.data;
                    console.log(this.rows);
                    setTimeout(function () {
                        $("#Datatable").DataTable({
                            pagingType: "full_numbers",
                            pageLength: 10,
                            processing: true,
                            order: [[0, "desc"]],

                            dom: "Bfrtip",
                            buttons: [],
                            bRetrieve: true,
                        });
                    }, 1000);
                }.bind(this)
            );
        },
    },
    created: function () {
        this.getPosts();
    },
    filters: {
        dateCell(value) {
            let dt = new Date(value);

            return dt.getDate();
        },
        date(val) {
            return val ? val.toLocaleString() : "";
        },
    },
};
function formatDate(date) {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
}
</script>

<style lang="scss">
.VuePagination {
    text-align: center;
}

.vue-title {
    text-align: center;
    margin-bottom: 10px;
}

.vue-pagination-ad {
    text-align: center;
}

.glyphicon.glyphicon-eye-open {
    width: 16px;
    display: block;
    margin: 0 auto;
}

th:nth-child(3) {
    text-align: center;
}

.VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
}

.VueTables__child-row-toggler--closed::before {
    content: "+";
}

.VueTables__child-row-toggler--open::before {
    content: "-";
}

.accounting_bill_card {
    .card-header {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
    }
    .card_btn {
        display: flex;
        width: 100%;
        .btn {
            width: 100%;
            border-radius: 50px;
            i {
                font-size: 20px;
                vertical-align: bottom;
            }
        }
    }
    .account_bill_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
        p {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #454545;
        }
        h3 {
            margin: 0;
            font-weight: 600;
            font-size: 14px;
            min-width: 62px;
        }
        a {
            &:hover {
                color: #fff;
                background: #c41e3a !important;
            }
        }
    }
}
.account_datepicker_filter {
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    .input-group {
        width: auto;
        .input-group-text {
            i {
                font-size: 25px;
            }
        }
        .form-control {
            z-index: 1;
        }
    }
}
</style>
